<!-- Copied from V1 version -->

<template>
  <div class="ml-1 relative inline-block popup">
    <div class="help-bubble" v-show="show" role="tooltip">
      <button type="button" class="helpx" @click="show = false" tabindex="-1">X</button>
      <div class="helpmob"></div>{{ text }}<div class="helpmob"></div>
      <button type="button" class="helpokay" @click="show = false">Okay</button>
      <div class="helpmob"></div>
    </div>
    <a @keypress.enter.prevent="$event.target.click" type="button" tabindex="0" class="cursor-pointer" @click="show = !show">
      <QuestionIcon class="w-4 h-4 inline"/>
    </a>
  </div>
</template>

<script>

import QuestionIcon from '@/v2/assets/images/icons/question.svg'

export default {
  name: 'HelpPopup',
  props: {
    text: String,
  },
  data() {
    return {
      show: false,
    }
  },
  components: {
    QuestionIcon
  }
}
</script>